import { render, staticRenderFns } from "./noticeStyle.vue?vue&type=template&id=adae7f5c&scoped=true"
import script from "./noticeStyle.vue?vue&type=script&lang=js"
export * from "./noticeStyle.vue?vue&type=script&lang=js"
import style0 from "./noticeStyle.vue?vue&type=style&index=0&id=adae7f5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adae7f5c",
  null
  
)

export default component.exports